import filesize from './filesize'
import time from './time'

const Filters = {
  install (Vue) {
    filesize(Vue)
    time(Vue)
  }
}

export default Filters



// WEBPACK FOOTER //
// ./src/filters/index.js